import React from "react";
import { IconWithCircle } from "nemuru-components";
import { useTheme } from "@material-ui/styles";
import { Box } from "@material-ui/core";

function IconWithCircleButton({ onClick, disabled = false, children }) {
  const handleClick = (e) => {
    if (disabled) return;
    onClick?.(e);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      if (disabled) return;
      onClick?.(e);
    }
  };

  return (
    <Box
      role="button"
      aria-disabled={disabled}
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      style={{
        cursor: disabled ? "default" : "pointer",
        maxWidth: "32px",
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {children}
    </Box>
  );
}

export default function BackButton({ onBack, show, disabled = false }) {
  const { palette } = useTheme();

  return (
    <>
      {show && (
        <IconWithCircleButton onClick={onBack} disabled={disabled}>
          <IconWithCircle
            backgroundColor={palette.grey[50]}
            height={32}
            width={32}
            className="material-icons"
            style={{
              fontSize: 12,
              color: palette.text.primary,
              position: "relative",
              left: "3px",
            }}
          >
            arrow_back_ios
          </IconWithCircle>
        </IconWithCircleButton>
      )}
    </>
  );
}
